import { useEffect } from "react";
import { useUserStore } from "@/common/store/userStore";
import { bus } from "@/common/buses/metrics/bus";

export const useTrackUser = () => {
  const user = useUserStore((state) => state.currentUser);

  useEffect(() => {
    if (user?.username) {
      bus.emit("userFetched", { user });
    }
  }, [user]);
};
